var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M20 7.212s-6.666-1.326-6.666 2.654C13.334 13.85 13 21 13 25M8 14h11"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M17.585 24.25c3.688 0 6.665-2.853 6.665-6.356V7.105c0-3.502-2.977-6.355-6.665-6.355H7.415C3.727.75.75 3.603.75 7.105v10.789c0 3.503 2.977 6.356 6.665 6.356h10.17z"
  }))));
};
export { SvgFacebookIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjRkZGIj4KICAgICAgICA8ZyBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8cGF0aCBkPSJNMjAgNy4yMTJzLTYuNjY2LTEuMzI2LTYuNjY2IDIuNjU0QzEzLjMzNCAxMy44NSAxMyAyMSAxMyAyNU04IDE0aDExIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxwYXRoIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMTcuNTg1IDI0LjI1YzMuNjg4IDAgNi42NjUtMi44NTMgNi42NjUtNi4zNTZWNy4xMDVjMC0zLjUwMi0yLjk3Ny02LjM1NS02LjY2NS02LjM1NUg3LjQxNUMzLjcyNy43NS43NSAzLjYwMy43NSA3LjEwNXYxMC43ODljMCAzLjUwMyAyLjk3NyA2LjM1NiA2LjY2NSA2LjM1NmgxMC4xN3oiLz4KICAgIDwvZz4KPC9zdmc+Cg==";